import { render, staticRenderFns } from "./publishVideoPreview.vue?vue&type=template&id=b9fb8bfc"
import script from "./publishVideoPreview.vue?vue&type=script&lang=js"
export * from "./publishVideoPreview.vue?vue&type=script&lang=js"
import style0 from "./publishVideoPreview.vue?vue&type=style&index=0&id=b9fb8bfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports